export const templatesModule = {
    slug: 'templates',
    label: 'Templates',
    description: 'Print template editor (HTML + LiquidJS).',
    icon: 'LayoutTemplate',
};
//# sourceMappingURL=templates.js.map